import React from 'react';
import PropTypes from 'prop-types';

import Constants from "../utils/Constants";
import MoreInfo from "./MoreInfo";
import TwitterRedactionExplanation from "./TwitterRedactionExplanation";

import {
	makeStyles,
	Paper,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	redactedPaper: {
		padding: theme.spacing(1.5),
		backgroundColor: theme.palette.grey[100]
	}
}));

function TwitterRedaction(props) {
	let classes = styles(),
		{twitterRedacted, history, className, isAlert, shortMessage} = props;

	return (
		<Paper elevation={0} className={`${classes.redactedPaper} ${className}`}>
			<Typography color="textSecondary">
				{Constants.ACTIVITY.TWITTER_REDACTION.getMessage(twitterRedacted, shortMessage)}&nbsp;
				<MoreInfo
					maxWidth="xs"
					textToUse="Learn More"
					title="Why is this information no longer available?"
					content={<TwitterRedactionExplanation history={history} isAlert={isAlert} />} />
			</Typography>
		</Paper>
	);
}

TwitterRedaction.propTypes = {
	twitterRedacted: PropTypes.string,
	history: PropTypes.object.isRequired,
	className: PropTypes.string,
	isAlert: PropTypes.bool,
	shortMessage: PropTypes.bool
};

export default TwitterRedaction;